import { render, staticRenderFns } from "./VehicleIssuanceStockControl.vue?vue&type=template&id=c81434cc&scoped=true&"
import script from "./VehicleIssuanceStockControl.vue?vue&type=script&lang=js&"
export * from "./VehicleIssuanceStockControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81434cc",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QBtn} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel,QBtn}, component.options.components || {})
